import { StateFromReducersMapObject, configureStore } from '@reduxjs/toolkit';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { mainRootReducer } from './mainRootReducer';

export function configureMainStore(
  preloadedState?: StateFromReducersMapObject<typeof mainRootReducer>
) {
  return configureStore({
    preloadedState,
    reducer: mainRootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }),
  });
}

export type MainStore = ReturnType<typeof configureMainStore>;
export type GetState = MainStore['getState'];
export type Dispatch = MainStore['dispatch'];

export type Mutable<T> = {
  -readonly [P in keyof T]: T[P];
};

export type State = Mutable<ReturnType<GetState>>;
